/**
 * @generated SignedSource<<0c98acd810a8fc805d1c88584c2844b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNotePage_widgetNotePage$data = {
  readonly currentValue: string;
  readonly id: string;
  readonly version: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackground_widgetNotePage" | "useNoteWidgetStyleText_widgetNotePage">;
  readonly " $fragmentType": "WidgetNotePage_widgetNotePage";
};
export type WidgetNotePage_widgetNotePage$key = {
  readonly " $data"?: WidgetNotePage_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePage_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNotePage_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNotePageBackground_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "1c4e6963bc95059070afc985a4699a61";

export default node;
